import { Injectable } from '@angular/core';
import { ITenantTheme } from '../../config/tenant.interface';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  applyTheme(theme: ITenantTheme): void {
    const root = document.documentElement;
    const set = (v: string, val: string) => root.style.setProperty(v, val);

    set('--theme-color',      theme.primaryColor);
    set('--theme-color-dark', theme.primaryDark);
    set('--theme-secondary',  theme.secondaryColor);
    set('--theme-accent',     theme.accentColor);
    set('--theme-font-family', theme.fontFamily);
    set('--logo-url',    `url('${theme.logoUrl}')`);
    set('--logo-height', theme.logoHeight ?? '35px');

    const faint10 = this.hexToRgba(theme.primaryColor, 0.06);
    const faint30 = theme.colorFaint30 ?? this.hexToRgba(theme.primaryColor, 0.10);
    const faint50 = theme.colorFaint50 ?? this.hexToRgba(theme.primaryColor, 0.20);

    set('--theme-color-faint-10', faint10);
    set('--theme-color-faint-30', faint30);
    set('--theme-color-faint-50', faint50);

    // Button tokens derive from primary — override only the theme-specific ones;
    // danger / success / secondary stay as defined in variables.scss.
    set('--btn-primary-bg',           theme.primaryColor);
    set('--btn-primary-border',       theme.primaryColor);
    set('--btn-primary-hover-bg',     theme.primaryDark);
    set('--btn-primary-hover-border', theme.primaryDark);
    set('--btn-outline-color',        theme.primaryColor);
    set('--btn-outline-border',       theme.primaryColor);
    set('--btn-outline-hover-bg',     faint30);
  }

  setVar(name: string, value: string): void {
    document.documentElement.style.setProperty(name, value);
  }

  getVar(name: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  }

  private hexToRgba(hex: string, alpha: number): string {
    const clean = hex.replace('#', '');
    const full = clean.length === 3
      ? clean.split('').map(c => c + c).join('')
      : clean;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
